define('app/models/city_area_selector',['app/setup'], function(takhfifan) {
  takhfifan.CityAreaSelector = Backbone.Model.extend({

    initialize: function(args) {
      this.set('suburb', null);
      this.set('area', null);
      this.set('suburbs', []);
      this.set('areas', []);
      this.updateCities();

      if (this.get('city') != null) {
        this.updateSuburbs();
      }
    },

    areas: {
      '' : null,
      'تهران' : {
        '' : '',
        'تهران - منطقه ۱' : ['','اراج','ازگل','امامزاده قاسم','اوین','باغ فردوس','تجریش','جماران','چیذر','حصار بوعلی','دارآباد','درکه','دربند','دزاشیب','دزاشیب و جوزستان','رستم آباد','زعفرانیه','سوهانک','شهرک گلها','شهرک محلاتی','شهرک نفت','قیطریه','کاشانک','گلاب دره','محمودیه','نیاوران','ولنجک' ],
        'تهران - منطقه ۲' : ['','آلستوم','ایوانک','پاتریس','پردیسان','پرواز','پونک','تهران ویلا','توحید','چوب تراش','خرم رودی','درختی','دریا','زنجان','سپهر','سرو','سعادت آباد','شادمهر','شهرک آزمایش','شهرک بوعلی','شهرک مخابرات','شهرک هما','صادقیه','طرشت','فرحزاد','کوهسار','کوی نصر','مدیریت','همایون شهر' ],
        'تهران - منطقه ۳' : ['','آرارات','اختیاریه','ارسباران','امانیه','داودیه','درب دوم','دروس','زرگنده','قبا','قلهک','کاووسیه','ونک'],
        'تهران - منطقه ۴' : ['','اوقاف','پاسداران','تهران پارس','جوادیه ۴','حسین آباد','حکیمیه','خاک سفید','ده نارمک','شمس آباد','شمیرانو','شهرک ولیعصر','شیان','علم و صنعت','قاسم آباد','قنات کوثر','کاظم آباد','کالاد','کوهسار۴','لویزان','مبارک آباد','مجید آباد','مجیدیه','مهران','نارمک'],
        'تهران - منطقه ۵' : ['','المهدی','اندیشه','باغ فیض','بهاران','پونک','جنت آباد','حصارک','سازمان آب','سازمان برنامه','شاهین','شهر زیبا','شهران','شهرک آپادانه','شهرک اکباتان','کن','کوی ارم','کوی بیمه','محله ابوذر','محله فردوس','مرادآباد','مهران','نفت'],
        'تهران - منطقه ۶' : ['','آرژانتین','امیر آباد','ایرانشهر','بهجت آباد','ساعی','شریعتی','شیراز','عباس آباد','فاطمی','قایم مقام','قزل قلعه','کشاورز','گاندی','میدان جهاد','میدان ولیعصر','نصرت','یوسف آباد'],
        'تهران - منطقه ۷' : ['','ارامنه','امجدیه','اندیشه','باغ صبا','بهار','حشمتیه','خاقانی','خواجه نظام','دهقان','سهروردی','شارق','شهید نقدی','قصر','گرگان','نظام آباد','نیلوفر'],
        'تهران - منطقه ۸' : ['','تسلیحات','تهران پارس','دردشت','زرکش','فدک','کرمان','لشگر','مجیدیه','مداین','نارمک','هفت حوض','وحیدیه'],
        'تهران - منطقه ۹' : ['','استاد معین','امامزاده عبدلله','دکتر هوشیار','شمشیری','شهید دستغیب','فتح'],
        'تهران - منطقه ۱۰' : ['','بریانک','زنجان','سرسبیل','سلیمانی','شبیری چی','کارون','هاشمی','هفت چنار'],
        'تهران - منطقه ۱۱' : ['','آذربایجان','آگاهی','اسکندری','امیر بهادر','امیریه','انبار نفت','انقلاب','جمالزاده','جمهوری','خرم شهر','راه آهن','شیخ هادی','عباسی','فلسطین','مخصوص','منیریه','میدان حر','هلال احمر'],
        'تهران - منطقه ۱۲' : ['','آبشار','ارگ پامنار','امامزاده یحیی','ایران','بهارستان','تختی','دروازه شمیران','سنگلج','فردوسی','قیام','کوثر'],
        'تهران - منطقه ۱۳' : ['','آشتیانی','امامت','حافظیه','دهقان','زینبیه','سرخه حصار','شورا','قاسم آباد','نیروی هوایی'],
        'تهران - منطقه ۱۴' : ['','آهنگ','آهنگران','ابوذر','بروجردی','پرستار','تاکسیرانی','جابری','جوادیه','چهارصد دستگاه','خاوران','دژکام','دولاب','سیزده آبان','شاهین','شکوفه','شکیب','شهرایی','شیوا','صد دستگاه','فرزانه','قصر فیروزه','مینا','نبی اکرم','نیکنام'],
        'تهران - منطقه ۱۵' : ['','ابوذر','اتابک','اسلام آباد – والفجر','افسریه','دهقان-بروجردی','شهرک رضویه','شوش','طیب','کیان شهر','مسعودیه','مشیریه','مطهری','مظاهری','مینایی','هاشم آباد','ولیعصر'],
        'تهران - منطقه ۱۶' : ['','باغ آذری','تخت','جوادیه','خزانه','شهرک بعثت','علی آباد','نازی آباد','یاخچی آباد'],
        'تهران - منطقه ۱۷' : ['','آذری','امام زاده حسن','باغ خزانه','بلورسازی','جلیلی','زمزم','زهتابی','فلاح','گلچین','مقدم','وسفنارد','یافت آباد'],
        'تهران - منطقه ۱۸' : ['','بهداشت','تولید دارو','حسینی فردوس','خلیج فارس','شاد آباد','شمس آباد','شهرک امام خمینی','شهید رجایی','صاحب الزمان','صادقیه','هفده شهریور','ولیعصر','یافت آباد'],
        'تهران - منطقه ۱۹' : ['','اسفندیاری','اسماعیل آباد','بهمنیار','بوستان ولایت','خانی آباد نو','دولت خواه','شریعتی','شکوفه','شهرک احمد خمینی','شهرک رسالت','شهید کاطمی','علی آباد','نعمت آباد'],
        'تهران - منطقه ۲۰' : ['','استخر','اقدسیه','تقی آباد','جوانمرد قصاب','حمزه آباد','دولت آباد','دیلمان','سر تخت','سیزده آبان','شهادت','شهید بهشتی','صفاییه','علایین','فیروز آبادی','منصوریه','هاشم آباد','ولی آباد'],
        'تهران - منطقه ۲۱' : ['','تهرانسر','چیتگر','شهرک آزادی','شهرک استقلال','شهرک دانشگاه تهران','شهرک شهرداری','شهرک غزالی','شهرک فرهنگیان','وردآورد','ویلاشهر'],
        'تهران - منطقه ۲۲' : ['','آزاد شهر-پیکان شهر','امید دژبان','دهکده المپیک','زیبادشت','شهرک دانشگاه شریف','شهرک شهید باقری','گلستان']
      },
      'تبریز' : null,
      'مشهد' : null,
      'اصفهان' : null,
      'شیراز' : null,
      'کرج' : null,
      'اراک' : null,
      'اهواز' : null,
      'بندرعباس' : null,
      'رشت' : null,
      'زاهدان' : null,
      'ساری' : null,
      'قزوین' : null,
      'قم' : null,
      'نوشهر' : null,
      'همدان' : null,
      'کرمان' : null,
      'کیش' : null,
      'یزد' : null,
      'گرگان' : null,
      'کرمانشاه' : null,
      'ارومیه' : null,
      'اردبیل' : null,
      'زنجان' : null,
      'خرم آباد' : null,
      'سنندج' : null,
      'بوشهر' : null,
      'بجنورد' : null,
      'بیرجند' : null,
      'ایلام' : null,
      'سمنان' : null,
      'یاسوج' : null,
      'بروجرد' : null
    },

    updateCities: function() {
      if (typeof this.get('cities') === 'undefined') {
        var cities = [];

        for (var key in this.areas) {
          cities.push(key);
        }
        this.set('cities', cities);
      }
    },

    updateSuburbs: function() {
      var suburbs = [];
      var city = this.get('city');

      if (this.areas[city]) {
        for (var key in this.areas[city]) {
          suburbs.push(key);
        }
      }

      this.set('suburb', null);
      this.set('suburbs', suburbs);
    },

    updateAreas: function() {
      var city = this.get('city');
      var suburb = this.get('suburb');

      if (city == '' || suburb == null) {
        this.set('areas', []);
      } else {
        this.set('areas', this.areas[city][suburb]);
      }
    }

  });

});

